import { modals } from '@mantine/modals';

import { useDeleteUserMutation } from '../store/users-api';
import { handleUserDeleteError } from '../utils/helpers/users-errors';
import { useShowResponseStatus } from '@/shared';

import type { TUser } from '../store/types';

export const useDeleteUser = () => {
  const [deleteUser, { isLoading, isSuccess, error }] = useDeleteUserMutation();
  const deleteError = handleUserDeleteError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Пользователь успешно удалён',
    error: deleteError,
  });

  const openDeleteModal = (item: TUser) =>
    modals.openConfirmModal({
      title: `Удаление пользователя с ID ${item.id}`,
      centered: true,
      children: `Вы точно хотите удалить пользователя "${item.name}"?`,
      labels: { confirm: 'Удалить', cancel: 'Отмена' },
      confirmProps: { color: 'red' },
      onConfirm: async () => await deleteUser({ userId: item.id }),
    });

  return {
    deleteUser,
    openDeleteModal,
    isLoading,
  };
};
